module.exports = __webpack_public_path__ + "static/media/Slide_5.5429a20a.png";